import * as Content from '../reducers/Content'
import Tiler from './Tiler'

const nodeWidth = 182
const rowSpacing = 8

const nodeHeight = nodeWidth / 1.75
const rowHeight = (nodeHeight - rowSpacing) / 2

export const metric = {
  columnWidth: nodeWidth,
  columnSpacing: 8,
  rowHeight,
  rowSpacing,
}

export function rowCount(node) {
  switch (Content.nodeType(node)) {
    case 'image':
    case 'video':
      return 2
    case 'text':
    case 'folder':
    default:
      return 1
  }
}

export function layout(nodes) {
  const tiler = new Tiler(metric)

  const tiles = nodes.map((node) => ({
    node,
    rect: tiler.addTile(rowCount(node), 1),
  }))

  return {
    height: tiler.size.height + metric.columnSpacing,
    tiles,
  }
}

export function dropFrames(nodes, dragNode) {
  const tiler = new Tiler(metric)

  const dragRowCount = rowCount(dragNode)

  const frames = []
  let dragRect = {}
  let index = 0

  nodes.forEach((node) => {
    const dropRect = tiler.clone().addTile(dragRowCount, 1)

    if (node !== dragNode) {
      frames.push({ index, rect: dropRect })
      index += 1
      tiler.addTile(rowCount(node), 1)
    } else {
      dragRect = dropRect
    }
  })

  const dropRect = tiler.addTile(dragRowCount, 1)
  frames.push({ index, rect: dropRect })

  const dragStartX = dragRect.x + dragRect.width / 2
  const dragStartY = dragRect.y + dragRect.height / 2

  return frames.map((frame) => {
    const { rect } = frame
    return {
      index: frame.index,
      rect: {
        x: rect.x - dragStartX,
        y: rect.y - dragStartY,
        width: rect.width,
        height: rect.height,
        column: rect.column,
      },
    }
  })
}
